import React, {useEffect, useState} from 'react';
import styles from './ChallengeCard.module.css';
import AttendeesAndFollowedUsers from '../AttendeesAndFollowedUsers';
import ChallengeCardHeader from './ChallengeCardHeader';
import {rwbApi} from '../../../../shared/apis/api';
import {
  CHALLENGE_ERRORS,
  JOIN_CHALLENGE_ERROR,
} from '../../../../shared/constants/ErrorMessages';
import {errorAlert} from '../../../../shared/utils/ErrorAlert';

const UnjoinedChallengeCard = ({
  title,
  endTime,
  description,
  challengeId,
  refreshChallenges,
  startTime,
  badgeURL,
}) => {
  const [loading, setLoading] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [followingParticipants, setFollowingParticipants] = useState();
  const [participantsCount, setParticipantsCount] = useState(0);

  useEffect(() => {
    if (challengeId) {
      Promise.all([getParticipants(), getFollowingParticipants()]).then(
        ([participants, followingParticipants]) => {
          setParticipants(participants.participants);
          setFollowingParticipants(followingParticipants[0].attendees);
          setParticipantsCount(participants.total_count);
        },
      );
    }
  }, []);

  const getParticipants = () => {
    return rwbApi.getChallengeParticipants(challengeId).then((res) => {
      return res;
    });
  };

  const getFollowingParticipants = () => {
    return rwbApi.getChallengeFollowingParticipants(challengeId).then((res) => {
      return res;
    });
  };

  const joinChallenge = (e) => {
    // prevent the link from navigating to the challenge
    // when pressing join
    e.stopPropagation();
    e.preventDefault();
    setLoading(true);
    rwbApi
      .joinChallenge(challengeId)
      .then(() => {
        refreshChallenges();
      })
      .catch((err) => {
        errorAlert(CHALLENGE_ERRORS.JOIN);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className={styles.container} style={{opacity: loading ? 0.5 : null}}>
      <ChallengeCardHeader
        title={title}
        endTime={endTime}
        startTime={startTime}
        badgeURL={badgeURL}
      />
      <p className={styles.description}>{description}</p>
      {participants.length > 0 && (
        <AttendeesAndFollowedUsers
          attendees={participants}
          followingAttendees={followingParticipants}
          attendeesCount={participantsCount}
          maxAttendees={0}
        />
      )}
      <div onClick={joinChallenge} className={styles.joinButton}>
        Join Challenge
      </div>
    </div>
  );
};

export default UnjoinedChallengeCard;
